module.exports = __webpack_public_path__ + "media/images/slide_2-94d7b764ffa86b8bd02bf6c968895d16.png";